const IS_SIMPLE = /^[a-zA-Z0-9äöü.]*$/i;

export function foolproofTerm(term: string) {
  let foolproofed = term;

  if (IS_SIMPLE.test(term) === false) {
    foolproofed = `"${term}"`;
  }

  return foolproofed;
}
